export class HTMLSanitizer {
    constructor() {
        this.ltPattern = /</g;
        this.gtPattern = />/g;
    }
    escapeFullHtml(unsafe) {
        if (unsafe === null || unsafe === undefined) {
            return unsafe;
        }
        return unsafe.replace(/&/g, '&amp;').replace(this.ltPattern, '&lt;').replace(this.gtPattern, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
    escapeLtGtHtml(unsafe) {
        if (unsafe === null || unsafe === undefined) {
            return unsafe;
        }
        return unsafe.replace(this.ltPattern, '&lt;').replace(this.gtPattern, '&gt;');
    }
}
export default new HTMLSanitizer();
